<template>
  <alert class="mb-0" icon="mdi-information-outline" icon-color="#F44336" text-color="#E31B0C" color="#F443361A">
    <template #default>
      <slot></slot>
    </template>
  </alert>
</template>

<script>
import Alert from '@/component/Alert/alert';

export default {
  name: 'AlertError',
  components: {
    Alert,
  },
};
</script>

<style lang="scss" scoped></style>
